import React from 'react';
import { useLocation } from 'react-router-dom';
import { FEATURE_ID, ROUTE } from '../../../Common/constant';
import AboutUs from "../../../assets/images/banner/vsim.png";
import BannerBg from "../../../assets/images/shapes/shape-02.png";


const About = () => {
  const { pathname } = useLocation()
  const isAtHome = pathname === ROUTE.BASE_URL

  return (
    <section id={FEATURE_ID.ABOUT} className="about__section p_relative see__pad" style={{ paddingTop: "120px" }}>
      <div className="pattern-layer">
        <div
          className="pattern-2 p_absolute"
          data-parallax={{ "x": -50 }}
          style={{ backgroundImage: `url(${BannerBg})` }}
        ></div>
      </div>
      <div className="boild__text">
        <h1>K-EGP</h1>
      </div>
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="about__block p_relative">
              <figure
                className="wow zoomIn animated"
                data-wow-delay="100ms"
                data-wow-duration="1500ms"
              >
                <img src={AboutUs} alt="" />
              </figure>
              {/*
              <div
                className="funfact__content about"
                style={{ backgroundImage: `url(${shape1})` }}
              >
                <div className="count-outer count-box">
                  <h1 className="count-text">
                  <CountUp start={0} end={10} /><span>K+</span>
                  </h1>
                  
                </div>
                <p>World wide Client</p>
              </div>
              */}
            </div>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5 col-md-12">
            <div className="about__text__block">
              <div className="sub__title">
                <h4>About K-EGP</h4>
              </div>
              <div className="title two">
                <h2>
                  Enhancing Real-world Experiences with The Latest <span>Technology</span>.
                </h2>
              </div>
              <div className="texts">
                <p>
                  Our integrated solution offering cover a range of latest technologies such as Simulator, Sensor Device, Virtual Reality, Data Acquisition / Automation, Data Analytics – Operator Behavior and Risk Profile, Assets Tracking System, Management Consulting and Training.
                </p>
              </div>

              {/* {isAtHome &&
                <div className="btn-box">
                  <Link to={ROUTE.ABOUT_US} className="theme-btn theme-btn-one">
                    <i className="icon-02"></i>see more
                  </Link>
                </div>
              } */}
            </div>
          </div>
        </div>
      </div>
      <div className="auto-container">
        <div className="vision_mission_wrapper">
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "12px" }}>
            <div className="sub__title">
              <h4>Our Vision</h4>
            </div>
            <div className="texts">
              <p style={{ textAlign: "center" }}>
                To be the most competitive and competent technology provider with Creative Driven Approach
              </p>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "12px" }}>
            <div className="sub__title">
              <h4>Our Mission</h4>
            </div>
            <div className="texts">
              <p style={{ textAlign: "center" }}>
                Enabling the latest innovation Technology that can improve and optimize the Process, Efficient Operation and People Productivity
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="auto-container" style={{ marginTop: "64px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <div className="sub__title">
          <h4>Value</h4>
        </div>
        <div className="col-xl-8 col-lg-10 col-sm-12" style={{ marginTop: "32px" }}>
          <div className="core_value_wrapper">
            <div className="core_value_content one">
              <h4>Team</h4>
              <p>We are growth together</p>
            </div>
            <div className="core_value_content two">
              <h4>Client</h4>
              <p>We hear you</p>
            </div>
            <div className="core_value_content one">
              <h4>Outcome</h4>
              {/* <div className="count-outer count-box">
                <h1 className="service__text"></h1>
              </div> */}
              <p>We get it done</p>
            </div>
            <div className="core_value_content two remove_gap_core_value_1">
              <h4>Growth</h4>
              <p>No boundary</p>
            </div>
            <div className="core_value_content one remove_gap_core_value_2">
              <h4>Agile</h4>
              <p>Move quickly and easily</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
